const loadMap = (el, google, pos) => {
    const mapSearchInput = document.querySelector('.cms-content-slice-clean-air-zone-map__search-input');

    const map = new google.maps.Map(el, {
        center: pos ? pos : { lat: 51.5074, lng: 0.1278 },
        zoom: 9,
        disableDefaultUI: true,
        zoomControl: true,
    });

    const searchBox = new google.maps.places.SearchBox(mapSearchInput);
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(mapSearchInput);

    map.addListener("bounds_changed", () => {
        searchBox.setBounds(map.getBounds());
    });

    let markers = [];

    searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
            return;
        }

        markers.forEach((marker) => {
            marker.setMap(null);
        });
        markers = [];

        const bounds = new google.maps.LatLngBounds();

        places.forEach((place) => {
            if (!place.geometry) {
                console.error("Returned place contains no geometry");
                return;
            }

            const icon = {
                url: place.icon,
                size: new google.maps.Size(71, 71),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(17, 34),
                scaledSize: new google.maps.Size(25, 25),
            };

            markers.push(
                new google.maps.Marker({
                    map,
                    icon,
                    title: place.name,
                    position: place.geometry.location,
                })
            );

            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport);
            } else {
                bounds.extend(place.geometry.location);
            }

            map.fitBounds(bounds);
        });
    });

    const files = [
        "/js/clean-air-zone/Ultra_Low_Emission_Zone_(ULEZ).geojson",
        "/js/clean-air-zone/Bath CAZ 2020.geoJSON",
        "/js/clean-air-zone/Birmingham CAZ 2020.geoJSON",
        "/js/clean-air-zone/Bradford CAZ 2021.geoJSON",
        "/js/clean-air-zone/Bristol CAZ 2021.geoJSON",
        "/js/clean-air-zone/Newcastle CAZ 2021.geoJSON",
        "/js/clean-air-zone/Portsmouth CAZ 2021.geoJSON",
        "/js/clean-air-zone/Sheffield CAZ.geoJSON",
        "/js/clean-air-zone/London CCZ_ULEZ 2019.geoJSON",
    ];

    files.forEach(file => {
        map.data.loadGeoJson(file);
    })
    map.data.setStyle(function(feature) {
        return {
            strokeColor: feature.getProperty('stroke'),
            strokeOpacity: feature.getProperty('stroke-opacity'),
            strokeWeight: feature.getProperty('stroke-width'),
            fillColor: feature.getProperty('fill'),
            fillOpacity: feature.getProperty('fill-opacity'),
        }
    });
}


const getCurrentPosition = async () => {
    return await navigator.geolocation.getCurrentPosition();
}

export default function(el) {
    const pos = null;
    window.GoogleMapsLoader.getMap().then(async function (google) {
        await getCurrentPosition()
            .then(
                (position) => {
                    pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                }
            )
            .then(() => loadMap(el, google, pos))
            .catch(() => loadMap(el, google, null));
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/components/clean-air-zone/clean-air-zone-map.js